export const CORNER_SIZE = 15;
export const MIN_CORNER_SIZE = 5;
// 10 >= x <=40
export function scaleControlsCornerSize(fabricObject, size = CORNER_SIZE) {
  return fabricObject.on('scaling', function () {
    const scaledSize = 0.8 * Math.min(
      this.width * this.scaleX , this.height * this.scaleY
    );
    let newCornerSize = CORNER_SIZE;
    if (scaledSize >= MIN_CORNER_SIZE && scaledSize <=CORNER_SIZE) {
      newCornerSize = scaledSize;
    }
    if (scaledSize < MIN_CORNER_SIZE) {
      newCornerSize = MIN_CORNER_SIZE
    }
    this.set({
      cornerSize: newCornerSize,
    });
  });
}
